import { useQuery } from "@tanstack/react-query";
import { LuFileClock } from "react-icons/lu";
import { Link } from "react-router-dom";
import { handleFetchRequestsCount } from "../../api/requests";

export default function ManagePending() {
  const { data: count } = useQuery({
    queryKey: ["pendingCount"],
    queryFn:() => handleFetchRequestsCount({ status: 'pending' }),
  });
  return (
    <Link
      to={`/requests/status/pending`}
      className={`col-span-6 sm:col-span-4 lg:col-span-2 bg-blue-100 border-blue-200 p-4  border`}

    >
      <div className="flex justify-between">
        <div className="flex flex-col justify-center items-center">
          <div className="flex items-center">
            <LuFileClock color="#323232" size={24} />
          <div className="mx-2">Pending Requests</div>
          </div>
        </div>
        <div className="font-bold">{count}</div>
      </div>
    </Link>
  );
}
